import React from "react";
import { useOutletContext } from "react-router-dom";
import AboutUs from "../components/about_us";

export default function AboutPage() {
  const { content, text } = useOutletContext();

  return <AboutUs title={text.Arabic9} description={content?.about_us} />;
}
